let general = {
  footer: {
    fondo: {background_color: ""},
    identidad: {url_site: '#', logo: '', color: ''},
    texto: {color: "", font_size: ""},
    enlaces: {enlace1: {nombre: "", url: "#"}, enlace2: {nombre: "", url: "#"}},
  },
  cabecera: {
    barraNavegacion: {
      nombre: {color: '', font_size: ''},
      idioma: {color: '', font_size: ''}
    }
  },
  paginaInicio: {
    cabecera: {color: '', font_size: ''},
    grupoCategorias: {font_size: '', color: ''},
  },
  unaCategoria: {
    menuUbicacion: {font_size: '', color: ''},
    tituloPrincipal: {color: '', font_size: ''},
    tituloSecundario: {color: '', font_size: ''}
  },
  barraNavegacion: {
    nombre: {color: "", font_size: ''},
    idioma: {color: "", font_size: 72}
  }
};
export default {
  formateadorEstiloPanelJson: {
    cargarEstilo: function (parametros) {
      for (var i = 0; i < parametros.length; i++) {
        console.log('for ', i);
        switch (parametros[i].nombre) {
          case 'footer':
            let footer = JSON.parse(parametros[i].estilo);
            general.footer = {
              fondo: {background_color: footer.fondo['background-color']},
              texto: {
                color: footer.texto['color'],
                font_size: footer.texto['font-size']
              },
              identidad: {
                url_site: footer.identidad.url_site,
                logo: footer.identidad.logo,
                color: footer.identidad.color
              },
              enlaces: {
                enlace1: {nombre: footer.enlaces.enlace1['nombre'], url: footer.enlaces.enlace1['url']},
                enlace2: {nombre: footer.enlaces.enlace2['nombre'], url: footer.enlaces.enlace2['url']}
              }
            };
            break;
          case 'cabecera':
            let cabecera = JSON.parse(parametros[i].estilo);
            general.cabecera = {
              barraNavegacion: {
                nombre: {
                  color: cabecera.barraNavegacion.nombre.color,
                  font_size: cabecera.barraNavegacion.nombre["font-size"]
                },
                idioma: {
                  color: cabecera.barraNavegacion.idioma.color,
                  font_size: cabecera.barraNavegacion.idioma["font-size"]
                }
              }
            };
            break;
          case 'barraNavegacion':
            let barraNavegacion = JSON.parse(parametros[i].estilo);
            general.barraNavegacion = {
              barraNavegacion: {
                nombre: {
                  color: barraNavegacion.barraNavegacion.nombre.color,
                  font_size: barraNavegacion.barraNavegacion.nombre["font-size"]
                },
                idioma: {
                  color: barraNavegacion.barraNavegacion.idioma.color,
                  font_size: barraNavegacion.barraNavegacion.idioma["font-size"]
                }
              }
            };
            break;
          case 'paginaInicio':
            let paginaInicio = JSON.parse(parametros[i].estilo);
            general.paginaInicio = {
              cabecera: {
                color: paginaInicio.cabecera.color,
                font_size: paginaInicio.cabecera['font-size']
              },
              grupoCategorias: {
                font_size: paginaInicio.grupoCategorias['font-size'],
                color: paginaInicio.grupoCategorias.color
              },
            };
            break;
          case 'unaCategoria':
            let unaCategoria = JSON.parse(parametros[i].estilo);
            general.unaCategoria = {
              menuUbicacion: {
                font_size: unaCategoria.unaCategoria.menuUbicacion['font-size'],
                color: unaCategoria.unaCategoria.menuUbicacion.color
              },
              tituloPrincipal: {
                color: unaCategoria.unaCategoria.tituloPrincipal.color,
                font_size: unaCategoria.unaCategoria.tituloPrincipal['font-size']
              },
              tituloSecundario: {
                color: unaCategoria.unaCategoria.tituloSecundario.color,
                font_size: unaCategoria.unaCategoria.tituloSecundario['font-size']
              }
            };
            break;
          default:
            break;
        }
      }
      return general;
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/compartida/estilosFomateadorJson.js